import { mountLegislature } from './utils/mount-legislature.js';
import { STATE_URL } from './constants.js';
mountLegislature('california-state-senate', STATE_URL, 'Z').catch(
  console.error
);
